/**
 * safely extract the first word in the given text, honoring all kinds of
 * whitespace as word delimeters and ignoring leading whitespace.
 */
export function getFirstWordInText(text: string): string {
  return text.trimLeft().replace(/\s/, " ").split(" ")[0] ?? "";
}
